import {
  DesktopFiltersDropdown,
  DesktopFiltersToolbar,
  DesktopFilterTag,
} from "features/filters/components";

import { typedObjectEntries } from "common/helpers/utils";

import { ACCOUNTS_FILTERS } from "../../constants";
import AccountFilterOptions from "../AccountFilterOptions";

import type { AccountSearchParams } from "../../types";

interface DesktopFiltersProps {
  searchParams: AccountSearchParams;
  setSearchParams: (searchParams: AccountSearchParams) => void;
  clearAllFilters: (() => void) | undefined;
}

export default function DesktopFilters({
  searchParams,
  setSearchParams,
  clearAllFilters,
}: DesktopFiltersProps) {
  return (
    <DesktopFiltersToolbar clearAllFilters={clearAllFilters}>
      {typedObjectEntries(searchParams).map(([key, selectedFilters]) => {
        if (selectedFilters.length) {
          const { icon, label } = ACCOUNTS_FILTERS[key];

          const selectedFiltersLabels = selectedFilters.map((id) => {
            const { options } = ACCOUNTS_FILTERS[key];
            return options[id as keyof typeof options];
          });

          return (
            <DesktopFilterTag
              key={key}
              icon={icon}
              label={label}
              selectedFilters={selectedFiltersLabels}
              onRemove={() => setSearchParams({ ...searchParams, [key]: [] })}
            >
              <AccountFilterOptions
                searchParamsKey={key}
                searchParams={searchParams}
                setSearchParams={setSearchParams}
              />
            </DesktopFilterTag>
          );
        }
      })}

      <DesktopFiltersDropdown
        filters={ACCOUNTS_FILTERS}
        renderFilter={(filterKey) => (
          <AccountFilterOptions
            searchParamsKey={filterKey}
            setSearchParams={setSearchParams}
            searchParams={searchParams}
          />
        )}
        hasFilters={!!clearAllFilters}
      />
    </DesktopFiltersToolbar>
  );
}
